export const CalculateServicePrice = (quantity, optionPrice) => {
  const totalPrice = quantity > 0 ? quantity * optionPrice : 0

  return totalPrice
}
